<template>
  <div class="">
      <div class="shengcheng" @click="toImage">生成海报</div>
      <div ref="imageWrapper">
        <img src="../assets/img/bj.png" width="100%" class="img"/>
        <div class="fikjui">
            <div>{{data.netClassCourseVo.courseName}}</div>
            <div>{{data.netClassCourseVo.schoolName}}</div>
            <div>{{dianhui(data.beginTime)}}-{{dianhui(data.endTime)}}</div>
            <div id="qrcode" class="qrcode yuxs" ref="qrCodeUrl" style="margin: 0px auto; border: 15px solid rgb(255, 255, 255)"></div>
            <div class="hongse">长按二维码进入直播</div>
        </div>
      </div>
      <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click="show = true">
          <!-- <van-image width="70%":src="imgUrl" class="yuhjus"/> -->
        <img :src="imgUrl" width="70%" class="yuhjus img"/>
        <div class="yuhuisd">长按保存海报</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { courseid, lessonzan } from "@/api/home";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import "videojs-contrib-hls";
import QRCode from "qrcodejs2";
import { Toast } from "vant";
import html2canvas from "html2canvas"
export default {
  data() {
    return {
      show: false,
      data:[],
      imgUrl:'',
      wxurl:''
    };
  },
  watch: {},
  components: {  },
  methods: {
    creatQrCode() {
        setTimeout(() => {
            document.getElementById("qrcode").innerHTML = "";
            var integrityurl = this.$route.query.url
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: integrityurl, // 需要转换为二维码的内容
                width: 120,
                height: 120,
                colorDark: "#FF6D4E",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
            });
          }, 500);
    },
    courseid() {
      let that = this;
      let params = {
        id: this.$route.query.id,
      };
      courseid(params)
        .then((res) => {
          that.data = res.data.data;
          that.creatQrCode()
        })
        .catch(() => {});
    },
    toImage() {
        html2canvas(this.$refs.imageWrapper, {
        useCORS: true 
      }).then((canvas) => {
        let imageUrl = canvas.toDataURL('image/png');
        this.imgUrl = imageUrl;
        this.show = true;
      }).catch((e) => console.log(e));

        // html2canvas(this.$refs.imageWrapper).then(canvas => {
        //   let dataURL = canvas.toDataURL("image/png");
        //   this.imgUrl = dataURL;
        //   if (this.imgUrl !== "") {
        //     this.show = true;
        //   }
        // });
      },
      dianhui(s){
        return s.slice(0, 16)
      },
  },
  mounted() {
    this.courseid();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/poster.vue